import { render, staticRenderFns } from "./method.vue?vue&type=template&id=3ddd2e5e&scoped=true&"
import script from "./method.vue?vue&type=script&lang=js&"
export * from "./method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddd2e5e",
  null
  
)

export default component.exports